(function () {
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $e73bd16ec0b3c415$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


var $a7750d407df0550c$var$controllers = new WeakMap();
var $a7750d407df0550c$var$postsGrid = {
    init: function() {
        var _this = this;
        document.querySelectorAll('.posts-grid').forEach(function(el) {
            return _this.bind(el);
        });
    },
    bind: function(el) {
        var _this = this;
        var sortEl = el.querySelector('.posts-grid__sort');
        var filterEl = el.querySelector('.posts-grid__filter');
        var paginationEl = el.querySelector('.posts-grid__pagination');
        if (sortEl) sortEl.addEventListener('change', function() {
            return _this.load(el, 1);
        });
        if (filterEl) filterEl.addEventListener('change', function() {
            return _this.load(el, 1);
        });
        if (paginationEl) paginationEl.addEventListener('click', function(e) {
            var link = e.target.closest('a[data-page]');
            if (!link) return;
            // Modified clicks open the real URL, e.g. in a new tab.
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            e.preventDefault();
            _this.load(el, parseInt(link.dataset.page, 10));
        });
    },
    load: function(el, page) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $554ed4b40b13e16f$export$71511d61b312f219)(function() {
            var _controllers_get, sortEl, filterEl, cardsEl, paginationEl, controller, body, response, data, err;
            return (0, $e73bd16ec0b3c415$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sortEl = el.querySelector('.posts-grid__sort');
                        filterEl = el.querySelector('.posts-grid__filter');
                        cardsEl = el.querySelector('.posts-grid__cards');
                        paginationEl = el.querySelector('.posts-grid__pagination');
                        (_controllers_get = $a7750d407df0550c$var$controllers.get(el)) === null || _controllers_get === void 0 ? void 0 : _controllers_get.abort();
                        controller = new AbortController();
                        $a7750d407df0550c$var$controllers.set(el, controller);
                        el.classList.add('posts-grid--loading');
                        body = new URLSearchParams({
                            action: postsGridAjax.action,
                            post_type: el.dataset.postType,
                            per_page: el.dataset.perPage,
                            sort_by: sortEl ? sortEl.value : 'date-desc',
                            filter_term: filterEl ? filterEl.value : '',
                            event_type: el.dataset.eventTypeFilter || 'all',
                            page_param: el.dataset.pageParam || '',
                            base_url: el.dataset.baseUrl || '',
                            page: page
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            fetch(postsGridAjax.ajax_url, {
                                method: 'POST',
                                body: body,
                                signal: controller.signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (!data.result) return [
                            2
                        ];
                        cardsEl.innerHTML = data.cards_html;
                        paginationEl.innerHTML = data.pagination_html;
                        paginationEl.hidden = !data.pagination_html.trim();
                        el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        err = _state.sent();
                        if (err.name !== 'AbortError') console.error('posts-grid AJAX failed:', err);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        el.classList.remove('posts-grid--loading');
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
    return $a7750d407df0550c$var$postsGrid.init();
});
else $a7750d407df0550c$var$postsGrid.init();

})();
//# sourceMappingURL=ajax.js.map
